const Statistics = Mach.requireModule('Statistics');

const mv = (cid: string, bid: string, val = {}) => {
  if (!cid || !bid) {
    return;
  }
  Statistics.view(cid, bid, val, 'sailor_c');
};

const mc = (cid: string, bid: string, val = {}) => {
  if (!cid || !bid) {
    return;
  }
  Statistics.click(cid, bid, val, 'sailor_c');
};

const DropOffLX = {
  // 当面交付选项
  dropOffOptionItemMC(cid, val) {
    mc(cid, 'b_sailor_c_js5jcuw9_mc', val);
  },
  // 当面交付-联系不上时MV
  dropOffCantReachItemMV(cid, val) {
    mv(cid, 'b_sailor_c_vk9xkuvc_mv', val);
  },
  // 当面交付-联系不上时MV
  dropOffCantReachItemMC(cid, val) {
    mc(cid, 'b_sailor_c_vk9xkuvc_mc', val);
  },
  // 放到指定地点
  dropOffDesignatedItemMV(cid, val) {
    mv(cid, 'b_sailor_c_0w2ads1c_mv', val);
  },
  dropOffDesignatedItemMC(cid, val) {
    mc(cid, 'b_sailor_c_0w2ads1c_mc', val);
  },
};

export default DropOffLX;
